<template>
    <div class="table-responsive">
        <table class="table table-hover no-overflow">
            <thead>
                <tr>
                    <th @click="$emit('sort', 'coverPage.referenceNumber')">
                        Folio carátula
                        <span v-if="coverPageStore.sortKey === 'coverPage.referenceNumber'">
                            <i :class="coverPageStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'loanApplications.referenceNumber')">
                        Folio solicitud
                        <span v-if="coverPageStore.sortKey === 'loanApplications.referenceNumber'">
                            <i :class="coverPageStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'prospects.referenceNumber')">
                        Folio prospecto
                        <span v-if="coverPageStore.sortKey === 'prospects.referenceNumber'">
                            <i :class="coverPageStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'products.referenceNumber')">
                        Folio producto
                        <span v-if="coverPageStore.sortKey === 'products.referenceNumber'">
                            <i :class="coverPageStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'products.productContract.referenceNumber')">
                        Folio contrato
                        <span v-if="coverPageStore.sortKey === 'products.productContract.referenceNumber'">
                            <i :class="coverPageStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'products.productType.name')">
                        Tipo de producto
                        <span v-if="coverPageStore.sortKey === 'products.productType.name'">
                            <i :class="coverPageStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'name')">
                        Nombre
                        <span v-if="coverPageStore.sortKey === 'name'">
                            <i :class="coverPageStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'prospects.personTypes.name')">
                        Tipo de persona
                        <span v-if="coverPageStore.sortKey === 'prospects.personTypes.name'">
                            <i :class="coverPageStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'coverPage.createdAt')">
                        Fecha creación
                        <span v-if="coverPageStore.sortKey === 'coverPage.createdAt'">
                            <i :class="coverPageStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'coverPage.updatedAt')">
                        Fecha actualización
                        <span v-if="coverPageStore.sortKey === 'coverPage.updatedAt'">
                            <i :class="coverPageStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="coverPages.length > 0">
                    <tr v-for="cover in coverPages" :key="cover.coverPage.id">
                        <td>{{ cover.coverPage.referenceNumber }}</td>
                        <td>{{ cover.loanApplications.referenceNumber }}</td>
                        <td>{{ cover.prospects.referenceNumber }}</td>
                        <td>{{ cover.products.referenceNumber }}</td>
                        <td>{{ cover.products.productContract.referenceNumber }}</td>
                        <td>{{ cover.products.productType.name }}</td>
                        <td>{{ getName(cover) }}</td>
                        <td>{{ cover.prospects.personTypes.name }}</td>
                        <td>{{ $filters.formatDate(cover.coverPage.createdAt) }}</td>
                        <td>{{ $filters.formatDate(cover.coverPage.updatedAt) }}</td>
                        <td>
                            <PrimaryButton class="btn-success" @click="$emit('edit', cover)" data-toggle="modal"
                                data-target="#contractCoverModal">
                                <i class="fa fa-edit"></i>
                            </PrimaryButton>
                        </td>
                    </tr>
                </template>
                <tr v-else>
                    <td colspan="10" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import PrimaryButton from '@/Components/PrimaryButton.vue';
import { useContractCoverStore } from '@/pinia/LoanApplications/Legal/useContractCoverStore.module';
import { getCurrentInstance } from 'vue';

const props = defineProps({
    coverPages: {
        type: Array,
        required: true,
        default: () => []
    }
});

/**
 * Abre el modal para editar un registro de carátula
 * Acción por el boton de la tabla
 */
const emit = defineEmits(['sort', 'edit']);

const coverPageStore = useContractCoverStore();

//Acceder a las propiedades globales
const instance = getCurrentInstance();
const $filters = instance?.appContext.config.globalProperties.$filters;

const getName = (item) => {
    if (item.prospects.generalInformation.businessName === null) {
        return `${item.prospects.generalInformation.firstName} ${item.prospects.generalInformation.lastName} ${item.prospects.generalInformation.mothersMaidenName}`;
    } else {
        return `${item.prospects.generalInformation.businessName}`;
    }
}
</script>